import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'

import LogisticsListStore from './LogisticsList/LogisticsList.store'

interface IProps {
  logisticsListStore: LogisticsListStore
  eventsStore: EventsStore
}

const ConfirmBatchStatusUpdateDialog: React.FC<IProps> = ({
  logisticsListStore,
  eventsStore,
}: IProps) => {
  const {
    isBatchStatusUpdateConfirmModalShown,
    closeBatchStatusUpdateConfirmModal,
    getSelectedNonDraftPermits,
    selectedStatusForBatchUpdate,
  } = logisticsListStore

  const confirmButtonText = Localization.translator.updateXWorkflows(
    getSelectedNonDraftPermits.length,
  )

  const handleConfirmBatchUpdateStatuses = () => {
    const {
      closeBatchStatusUpdateConfirmModal,
      batchUpdateStatuses,
      selectedStatusForBatchUpdate,
    } = logisticsListStore
    batchUpdateStatuses(selectedStatusForBatchUpdate, eventsStore)
    closeBatchStatusUpdateConfirmModal()
  }

  return (
    <ConfirmDialog
      isOpen={isBatchStatusUpdateConfirmModalShown}
      onCancelClicked={closeBatchStatusUpdateConfirmModal}
      onDoneClicked={handleConfirmBatchUpdateStatuses}
      doneTitle={confirmButtonText}
    >
      <div className="text large">
        {Localization.translator.youAreGoingToUpdate}{' '}
        <span className="text large bold">
          {Localization.translator.status}
        </span>{' '}
        {Localization.translator._to}
        <StatusBadge
          status={selectedStatusForBatchUpdate?.status}
          isLate={false}
          showDot={false}
          workflowStepLevel={
            selectedStatusForBatchUpdate?.workflowStepLevel ?? 0
          }
        />
        {Localization.translator._for}{' '}
        <span className="text large bold">
          {Localization.translator.xWorkflows(
            getSelectedNonDraftPermits.length,
          )}
        </span>
      </div>
    </ConfirmDialog>
  )
}

export default observer(ConfirmBatchStatusUpdateDialog)
